<template>
  <div>
    <Header></Header>
    <Expired v-if="failed" login="true"></Expired>
    <div v-else class="sign_up_page">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6">
            <div class="sign_up_box">
              <h1>{{ $t("auth.verification.loading") }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/styles/auth/main.scss";
import { mapActions } from "vuex";
import router from "@/router";

import Header from "@/components/auth/Header";
import Expired from "@/components/auth/Expired";

export default {
  components: {
    Header,
    Expired,
  },
  data() {
    return {
      failed: false,
    };
  },
  methods: {
    ...mapActions(["getToken"]),
  },
  async mounted() {
    document.body.classList.add("responsive", "intropage");

    if (this.$route.params) {
      if (this.$route.params.code == "no-data") {
        localStorage.setItem("login_no_data", true);
        this.$router.push("/login");
      } else {
        if (this.$route.params.code) {
          let data = {
            url: this.$w_api.GET_TOKEN,
            body: {
              code: this.$route.params.code,
            },
          };

          let res = await this.getToken(data);

          // getToken при ошибке отдаёт false — раньше в w_token писалось "undefined"
          if (!res || !res.token) {
            this.failed = true;
            return;
          }

          localStorage.setItem("w_clone_token", res.email);
          localStorage.setItem("w_token", res.token);

          if (window.innerWidth <= 1079) {
            let mData = {
              w_clone_token: localStorage.getItem("w_clone_token"),
              w_token: localStorage.getItem("w_token"),
            };
            window.postMessage({ action: "sendData", payload: mData }, "*");
          } else {
            if (localStorage.getItem("app_web_auth")) {
              // redirect to the open app page for app users
              localStorage.removeItem("app_web_auth");
              router.push({
                path: "/app_auth",
                query: {
                  useremail: res.user_email,
                },
              });
            } else {
              // redirect to inbox for web users
              setTimeout(() => {
                window.location.href = "/";
              }, 100);
            }
          }
        }
      }
    }
  },
  beforeDestroy() {
    document.body.classList.remove("responsive", "intropage");
  },
};
</script>
